<!--
 * @Author: nzj
 * @Date: 2023-03-23 11:27:27
 * @Description: 大客户拉新活动
-->
<template>
  <div class="page">
    <img src="https://pro-jms-front.oss-cn-shanghai.aliyuncs.com/baw/applets/auto/wechat_img/20240829-151154(1).png" alt="" style="width: 100%;position: absolute;top: 0;left:0;opacity: 0;z-index: -999;">
    <div class="container">
      <div class="banner"></div>
      <div class="input-div">
        <span class="input-title">留下信息，极兔带你领福利</span>
        <a-form-model ref="ruleForm" :rules="rules" :model="formData" class="input-modol">
          <div class="person-info">
            <a-form-model-item class="width50" prop="name">
              <a-input v-model.trim="formData.name" :maxLength="10" placeholder="请输入姓名">
                <div class="img-div" slot="prefix">
                  <img :src="nameImg" class="input_icon" alt="">
                </div>
              </a-input>
            </a-form-model-item>
            <a-form-model-item class="width50" prop="phone">
              <a-input v-model.trim="formData.phone" :maxLength="11" placeholder="请输入手机号">
                <div class="img-div" slot="prefix">
                  <img :src="phoneImg" class="input_icon" alt="">
                </div>
              </a-input>
            </a-form-model-item>
          </div>
          <div @click="checkAddress" class="position-ssq">
            <a-form-model-item prop="positionSSQ" class="input-info">
              <a-input v-model="formData.positionSSQ" placeholder="请选择省市区" readOnly :maxLength="200" prefix-icon="nameImg">
                <div class="img-div" slot="prefix">
                  <img :src="dizhiImg" class="input_icon dizhi" alt="">
                </div>
              </a-input>
            </a-form-model-item>
          </div>
          <a-form-model-item prop="address">
            <a-input v-model.trim="formData.address" :maxLength="100" placeholder="请输入详细地址（**路**号）">
              <div class="img-div" slot="prefix">
                <img :src="dizhiImg" class="input_icon dizhi" alt="">
              </div>
            </a-input>
          </a-form-model-item>
          <!-- <a-form-model-item prop="inviter">
            <a-input v-model.trim="formData.inviter" :maxLength="15" placeholder="请输入推荐人合作编码(J开头串码)-非必填">
              <div class="img-div" slot="prefix">
                <img :src="inviterIcon" class="input_icon dizhi" alt="">
              </div>
            </a-input>
          </a-form-model-item> -->
          <a-form-model-item class="code" prop="captcha">
            <a-input v-model.trim="formData.captcha" :maxLength="4" placeholder="请输入图片验证码">
              <div class="img-div" slot="prefix">
                <img :src="tupianImg" class="cap-code" alt="">
              </div>
              <div class="img-div" slot="suffix">
                <img class="img-code" @click="getCaptcha" :src="imgCodeUrl" alt="图片验证码">
              </div>
            </a-input>
          </a-form-model-item>
        </a-form-model>
        <a-button class="btn" type="primary" @click="subumit" :loading="loading">
          点击报名
        </a-button>
        <div class="coupon-icon">
          <img src="../../assets/img/pullNew2/coupon.png" alt="">
        </div>
      </div>
      <div class="detail-content">
        <img class="detail-img" src="../../assets/img/pullNew2/content-m.png" alt="">
        <img class="coupon-img-left" src="../../assets/img/pullNew2/coupon-left-pc.png" alt="">
        <img class="coupon-img-right" src="../../assets/img/pullNew2/coupon.png" alt="">
      </div>
    </div>

    <van-popup v-model="showAddressSelect" position="bottom">
      <div>
        <van-tabs v-model="tabActive" @click="handelTabChange" swipeable>
          <van-tab title="省">
            <div v-if="provinceList.length > 0" class="province-container" ref="provinceListRef">
              <div class="item-container"
                    :class="{'active': index === provinceIndex}"
                    v-for="(item, index) in provinceList" :key="index"
                    @click="handleSelected(item, index, 1)">
                {{ item.nativeName }}
              </div>
            </div>
          </van-tab>
          <van-tab title="市">
            <div v-if="cityList.length > 0 && tabActive === 1" class="city-container" ref="cityListRef">
              <div class="item-container"
                    :class="{'active': index === cityIndex}"
                    v-for="(item, index) in cityList" :key="index"
                    @click="handleSelected(item, index, 2)">
                {{ item.nativeName }}
              </div>
            </div>
            <div v-else class="empty">暂无数据</div>
          </van-tab>
          <van-tab title="区">
            <div v-if="countyList.length > 0 && tabActive === 2" class="area-container" ref="countyListRef">
              <div class="item-container"
                    :class="{'active': index === countyIndex}"
                    v-for="(item, index) in countyList" :key="index"
                    @click="handleSelected(item, index, 3)">
                {{ item.nativeName }}
              </div>
            </div>
            <div v-else class="empty">暂无数据</div>
          </van-tab>
        </van-tabs>
      </div>
    </van-popup>
  </div>
</template>

<script>
// 引入插件
// import '@/utils/TCaptcha'
import wx from 'weixin-js-sdk'
import { receiveBenefit, getAppletParams, pullNew } from '@/api'
import { PULL_NEW_SIGN_CODE_ACTIVITY, Appkey } from '@constants'
const ACTIVITY_CODE = 'J00005' // 活动编码
const nameImg = require('@/assets/img/geren@2x.png')
const phoneImg = require('@/assets/img/huafei@2x.png')
const tupianImg = require('@/assets/img/tupian@2x.png')
const dizhiImg = require('@/assets/img/dizhi@2x.png')
const couponImg = require('@/assets/img/pullNew/coupon.png')
const inviterIcon = require('@/assets/img/oldWithNew/inviter-icon.png')
export default {
  name: 'PullNew2',
  metaInfo: {
    title: '【贵州专享】极兔新客送福利！',
    meta: [
      { name: 'description', content: '寄满100送100，最高可送1000单，点击领取~' },
      {
        property: 'og:title',
        content: '【贵州专享】极兔新客送福利！',
        vmid: 'og:title',
      },
      {
        property: 'og:description',
        content: '寄满100送100，最高可送1000单，点击领取~',
        vmid: 'og:description',
      },
      {
        property: 'og:image',
        content: 'https://pro-jms-front.oss-cn-shanghai.aliyuncs.com/baw/applets/auto/wechat_img/20240829-151154(1).png',
        vmid: 'og:image',
      },
    ],
  },
  data() {
    return {
      loading: false,
      animateDuration: 0.3,
      nameImg,
      phoneImg,
      tupianImg,
      dizhiImg,
      inviterIcon,
      couponImg,
      formData: {
        captcha: '',
        ctoken: '',
        name: '',
        phone: '',
        positionSSQ: '',
        address: '',
        provinceName: '', // 省
        provinceId: '',
        cityName: '', // 市
        cityId: '',
        areaName: '',
        areaId: '',
        source: '', // 来源
        marketActivityCode: ACTIVITY_CODE,
        inviter: '', // 邀请人
      },
      value: '',
      rules: {},
      imgCodeUrl: '', // 图片验证码
      showAddressSelect: false,
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {},
      }, // 地址列表

      provinceList: [],
      cityList: [],
      countyList: [],
      tabActive: 0,
      provinceIndex: '', // 选中的省份索引
      cityIndex: '', // 选中的城市索引
      countyIndex: '', // 选中的地区索引

      areaObj: {
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        countyId: '',
        countyName: '',
      },

      bannerImg: '', // banner图
      swiperImage: [], // 轮播图
      activityDetail: '', // 活动规则
      areaOptions: [],
      captcha: '', // 腾讯滑块
    }
  },
  watch: {
    tabActive(val) {
      switch (val) {
        case 1:
          this.scrollGoTop('cityListRef', this.cityIndex)
          break
        case 2:
          this.scrollGoTop('countyListRef', this.countyIndex)
          break
        default:
          break
      }
    },
  },
  async created() {
    this.getCaptcha()
    this.getSource()
    this.refreshPageViews()
    await this.getAddressList(2, 1)
  },
  mounted() {
    this.immediateCouponCollection()
    // this.initTencentCaptcha()
  },
  methods: {
    // 切换省市时初始化滚动条
    scrollGoTop(ref, index) {
      this.$nextTick(() => {
        if (index === '' && this.$refs[ref]) {
          this.$refs[ref].scrollTop = 0
        }
      })
    },
    async getCaptcha() { //  获取图片验证码
      const { code, data } = await receiveBenefit.getCaptcha()
      if (code === 1) {
        this.imgCodeUrl = data.img
        this.formData.ctoken = data.ctoken
      }
    },
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      // eslint-disable-next-line no-undef
      this.captcha = new TencentCaptcha(Appkey, this.tencentCaptchaCallback)
    },
    // 验证码回调
    async tencentCaptchaCallback(res = {}) {
      console.log('腾讯验证码回调：callback', res)
      // 验证成功，返回对象
      if (res.ret === 0) {
        const { ticket, randstr } = res
        this.save({ ticket, randstr })
        return res
      }
      // 验证不成功
      return null
    },
    async refreshPageViews() {
      await pullNew.refreshPageViews({ marketActivityCode: ACTIVITY_CODE, source: this.formData.source })
    },
    get_env () { // 根据环境设置地址
      let env = ''
      const host = window.location.host
      if (host === 'uat-coupon.jtexpress.com.cn') {
        env = 'https://uat-coupon.jtexpress.com.cn'
      } else {
        env = 'https://coupon.jtexpress.com.cn'
      }
      return env
    },
    async immediateCouponCollection () {
      const env = this.get_env() // 当前环境域名
      const { source } = this.$route.query // 来源路径
      const WX_IMG_URL = 'https://pro-jms-front.oss-cn-shanghai.aliyuncs.com/baw/applets/auto/wechat_img/20240829-151154(1).png' // 微信分享图片
      const WX_Title = '【贵州专享】极兔新客送福利！' // 微信分享标题
      const WX_DES = '寄满100送100，最高可送1000单，点击领取~' // 微信分享描述
      const WX_LINK = `${env}/pullNew2?source=${source}`
      const { code, data } = await getAppletParams.getAppletParams(WX_LINK)
      if (code === 1) {
        wx.config({
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
          openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        })
        // 通过ready接口处理成功验证
        wx.ready(function () {
          wx.updateAppMessageShareData({
            link: WX_LINK,
            title: WX_Title, // 分享标题
            desc: WX_DES, // 分享描述
            imgUrl: WX_IMG_URL, // 分享图标
            type: 'link',
          })
        })

        wx.ready(function () { // 需在用户可能点击分享按钮前就先调用
          wx.updateTimelineShareData({
            link: WX_LINK,
            title: WX_Title, // 分享标题
            desc: WX_DES, // 分享描述
            imgUrl: WX_IMG_URL, // 分享图标
            type: 'link',
          })
        })

        // 通过error接口处理失败验证
        wx.error(function (res) {
          console.log(res, '通过error接口处理失败验证')
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
        })
      }
    },
    getSource() {
      const { source } = this.$route.query
      this.formData.source = source
    },
    checkAddress() {
      this.showAddressSelect = true
      this.scrollGoTop('provinceListRef', this.provinceIndex)
    },
    changearea(picker, values, column) {
      // values当前选中值
      // column当前滑动列索引012
      if (column === 0) {
        this.getAddressList(column + 3, Number(values[0].code))// 获取当前省下的城市
      } else if (column === 1) {
        this.getAddressList(column + 3, Number(values[1].code))// 获取当前省下的城市
      }
    },
    /**
     * 普通选择器逻辑
     * @param type
     * @param parentId
     * @returns {Promise<void>}
     */
    async getAddressList(type, parentId) {
      const params = {
        type,
        parentId,
        addressType: 1,
        filter: 1,
      }
      const { code, data } = await receiveBenefit.getAddressListFilter(params)
      if (code === 1) {
        if (type === 2) {
          this.provinceList = data
        } else if (type === 3) {
          this.cityList = data
        } else if (type === 4) {
          this.countyList = data
        }
      }
    },
    /**
     * 过滤地区数据
     * @param data
     * @returns {{children: [], id: *, text: *, parentId: *}[]|*[]}
     */
    areaFilter(data) {
      if (data instanceof Array) {
        return data.map(item => ({ id: item.id, text: item.nativeName, parentId: item.parentId, children: null }))
      } else {
        return []
      }
    },
    /**
     *
     * @param item
     * @param index
     * @param type
     */
    async handleSelected(item, index, type) {
      if (type === 1) {
        this.cityList = []
        this.provinceIndex = index
        this.areaObj.provinceId = item.id
        this.areaObj.provinceName = item.nativeName
        await this.getAddressList(3, item.id)
        this.cityIndex = ''
        this.countyIndex = ''
        this.tabActive = 1
      }
      if (type === 2) {
        this.countyList = []
        this.cityIndex = index
        this.areaObj.cityId = item.id
        this.areaObj.cityName = item.nativeName
        await this.getAddressList(4, item.id)
        this.countyIndex = ''
        this.tabActive = 2
      } else if (type === 3) {
        this.countyIndex = index

        this.formData.provinceId = this.areaObj.provinceId
        this.formData.provinceName = this.areaObj.provinceName
        this.formData.cityId = this.areaObj.cityId
        this.formData.cityName = this.areaObj.cityName
        this.formData.areaId = item.id
        this.formData.areaName = item.nativeName
        this.showAddressSelect = false
        this.formData.positionSSQ = `${this.formData.provinceName} / ${this.formData.cityName} / ${this.formData.areaName}`
      }
    },
    // tab
    handelTabChange(val) {
      // if (!this.formData.provinceId && val === 1) {
      //   return
      // }
      // if (!this.formData.cityId && val === 2) {
      //   return
      // }

      // this.tabActive = val
    },
    // 获取省市区数据
    async getAddressList111(type, parentId) {
      const params = {
        type,
        parentId,
        addressType: 1,
      }
      const { code, data } = await receiveBenefit.getAddressList(params)
      if (code === 1) {
        if (type === 2) {
          const province_temp = {}
          const province = data
          province.forEach(item => {
            province_temp[item.id] = item.nativeName
          })
          this.areaList['province_list'] = province_temp
        } else if (type === 3) {
          const city_temp = {}
          const city = data
          // 不要在循环中直接操作渲染的数据，存到变量上，之后一次给值
          city.forEach(item => {
            city_temp[item.id] = item.nativeName
          })
          this.areaList['city_list'] = city_temp
        } else if (type === 4) {
          const county_temp = {}
          const county = data
          county.forEach(item => {
            county_temp[item.id] = item.nativeName
          })
          this.areaList['county_list'] = county_temp
        }
      }
    },
    async confirm(e) {
      if (e[2] && e[2].code) {
        this.formData.provinceName = e[0].name // 省
        this.formData.provinceId = e[0].code // 省
        this.formData.cityName = e[1].name // 省
        this.formData.cityId = e[1].code // 省
        this.formData.areaName = e[2].name // 省
        this.formData.areaId = e[2].code // 省
        this.formData.positionSSQ = `${e[0].name} / ${e[1].name} / ${e[2].name}`
        this.showAddressSelect = false
      }
    },
    // 提交
    async subumit() {
      const reg = /^1[3456789]\d{9}$/
      const reg2 = /^J[0-9]{10,11}$/
      const { name, phone, positionSSQ, address, captcha, inviter } = this.formData
      if (!name) {
        this.$toast.fail({
          message: '请输入姓名',
          duration: 2000,
        })
        return
      }
      if (!phone) {
        this.$toast.fail({
          message: '请输入手机号',
          duration: 2000,
        })
        return
      }
      if (!reg.test(phone)) {
        this.$toast.fail({
          message: '请输入正确的手机号',
          duration: 2000,
        })
        return
      }
      if (!positionSSQ) {
        this.$toast.fail({
          message: '请选择省市区',
          duration: 2000,
        })
        return
      }
      if (!address) {
        this.$toast.fail({
          message: '请输入详细地址',
          duration: 2000,
        })
        return
      }
      if (inviter && !reg2.test(inviter)) {
        this.$toast.fail({
          message: '请输入正确的客户编码',
          duration: 2000,
        })
        return
      }
      if (!captcha) {
        this.$toast.fail({
          message: '请输入图片验证码',
          duration: 2000,
        })
        return
      }
      // this.captcha.show()
      this.save()
    },
    async save() {
      try {
        this.loading = true
        const times = new Date().valueOf()
        const sign = this.$md5(this.$md5(times + PULL_NEW_SIGN_CODE_ACTIVITY))
        const params = {
          times,
          sign,
          ...this.formData,
        }
        const { code, msg } = await pullNew.newCustomerActivitySp(params)
        if (code === 1) {
          this.$toast.success({
            message: '报名成功',
            duration: 2000,
          })
          this.resetForm()
        } else {
          this.getCaptcha()
          this.$toast.fail({
            message: msg,
            duration: 2000,
          })
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    resetForm() {
      this.getCaptcha()
      this.$refs.ruleForm.resetFields()
      this.formData.provinceName = ''
      this.formData.provinceId = ''
      this.formData.cityName = ''
      this.formData.cityId = ''
      this.formData.areaName = ''
      this.formData.areaId = ''
      this.tabActive = 0
      this.provinceIndex = ''
      this.cityIndex = ''
      this.countyIndex = ''
      this.cityList = []
      this.countyList = []
    },
    oncancel() {
      this.showAddressSelect = false
    },
  },
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 750rpx;
  background-image: url('../../assets/img/pullNew2/banner-m.png');
  background-size: 100% 100%;
}
.container {
  width: 100%;
  // height: 4010rpx;
  background-image: url('../../assets/img/pullNew2/bg-m.png');
  background-size: 100% 100%;
  // padding: 0 36rpx;
  box-sizing: border-box;
  margin-top: -1px;
  position: relative;
  padding-bottom: 100rpx;

  .input-div {
    width: 90%;
    background: #ffffff;
    text-align: center;
    padding: 30rpx 55rpx;
    box-sizing: border-box;
    border-radius: 8rpx;
    margin: 0 auto;
    position: relative;

    .coupon-icon {
      position: absolute;
      right: -34rpx;
      bottom: -110rpx;

      img {
        width: 240rpx;
      }
    }

    .input-title {
      display: inline-block;
      font-size: 32rpx;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #F20101;
      line-height: 32rpx;
      margin-bottom: 17rpx;
    }
    .input-modol {
      .person-info {
        display: flex;
        justify-content: space-between;
      }
      .position-ssq {
        min-height: 60rpx;
      }

      .img-div {
        display: flex;
        align-items: center;
        margin-left: 10rpx;
        position: relative;
        img {
          width: 27rpx;
          height: 35rpx;
          margin-left: -6px;
        }
        .cap-img {
          width: 32rpx;
          height: 20rpx;
        }
        .dizhi {
          width: 27rpx;
          height: 35rpx;
          margin-left: -6px;
        }
        .cap-code {
          width: 28rpx;
          height: 24rpx;
        }

        .img-code {
          width: 180rpx;
          height: 68rpx;
          position: absolute;
          right: -24rpx;
          top: -34rpx;
        }
      }
    }
    ::v-deep {
      .ant-input {
        font-size: 22rpx;
        height: 70rpx;
        padding-left: 60rpx;
        background: #F0F0F0;
        border-color: #d9d9d9;
        &::placeholder {
          font-size: 22rpx;
        }
      }
      .ant-form-item-control {
        line-height: 60rpx;
        margin-bottom: 15rpx;
      }
      .ant-form-item {
        margin-bottom: 0;
      }
      .el-input__prefix {
        display: flex;
        align-items: center;
      }
      .ant-form-item {
        min-height: 90rpx;
      }
      .ant-form-explain {
        text-align: left;
      }
      .ant-input-affix-wrapper {
        border-color: #EE0201;
      }
      .ant-input-affix-wrapper:hover {
        border-color: #EE0201;
      }
      .ant-input:hover {
        border-color: #EE0201;
      }
      .ant-input:focus {
        border-color: #EE0201;
        box-shadow: 0 0 0 2px rgb(238 2 1 / 20%)
      }
      .ant-btn-primary {
        border-color: #EE0201;
      }
    }
    .name-phone {
      display: flex;
      justify-content: space-between;
    }
    .width50 {
      width: 48%;
    }
    .code {
      .img-code {
        width: 100rpx;
        height: 80rpx;
      }
    }
    .btn {
      width: 227rpx;
      height: 62rpx;
      background: #E60000;
      border-radius: 5rpx;
      font-size: 32rpx;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #FFFFFF;
      margin: 10rpx auto 0;
      position: relative;
      img {
        position: absolute;
        right: -80rpx;
        top: 0;
        width: 70rpx;
      }
    }
  }
  .detail-title {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    img:nth-child(1) {
      margin-top: 42rpx;
      width: 168rpx;
      height: 44rpx;
    }
    img:nth-child(2) {
      width: 23rpx;
      height: 30rpx;
      margin: 17rpx 0 26rpx 0;
    }
  }
  .detail-content {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 46rpx;

    .detail-img {
      width: 90%;
    }

    .coupon-img-left {
      position: absolute;
      left: 0;
      bottom: 1876rpx;
      width: 200rpx;
    }

    .coupon-img-right {
      position: absolute;
      right: 0;
      bottom: 1080rpx;
      width: 200rpx;
    }
  }
  .qr-code {
    text-align: center;
    margin-top: 67rpx;
    img {
      width: 276rpx;
      height: 142rpx;
    }
  }
}

.area-container, .province-container, .city-container{
  overflow: scroll;
  height: 40vh;
  padding-bottom: 30rpx;

  .item-container {
    padding: 25rpx 20rpx;
    font-size: 26rpx;
    font-weight: 400;
    color: #666666;
    border-top: 1px solid #eeeeee;
    text-align: center;

    &.active {
      color: #e60000;
    }
  }
}

.empty {
  height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cccccc;
}

::v-deep {
  .van-tab__text {
    font-size: 28rpx;
  }

  .van-tabs__wrap {
    position: sticky;
    top: 0;
  }
}
</style>

